import React from 'react'
import './Organizer.scss'

const Organizer = ({organizer}) => {
    return <div className="wtm-organizer">
        <div className="content">
            <img className="img" src={organizer.src} alt="WOMAN TECHMAKERS 2019 SEOUL ORGANIZER"/>
            <h1>{organizer.name}</h1>
            <h3>{organizer.desc}</h3>

        </div>
        <div className="overlay">
        </div>
    </div>
}

export default Organizer
